import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { InvoicesPage } from "@/features/invoices/InvoicesPage";

const search = z.object({
  status: z.enum(["all", "draft", "sent", "viewed", "overdue", "partial", "paid"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/invoices/")({
  validateSearch: search,
  component: () => <InvoicesPage search={Route.useSearch()} />,
});
